<template>
  <AppSection>
    <AppContainer class="mb-7">
      <AppThirdLayout class="heading">
        <AppHeaderWithImg 
          :text="$tt('explore_visa_options')"
          src="/images/pass-icon.jpg"
          :alt="$tt('images.passport_icon')"
          class="header-with-img"
          row
        />
        <CountriesOverviewMenu />
      </AppThirdLayout>
    </AppContainer>
    <CountriesOverviewCarousel v-if="products" :products ref="carousel" />
  </AppSection>
</template>

<script setup lang="ts">
import { getAllProducts } from '~/helpers/http';

const { data: products } = await useAsyncData(getAllProducts);
if (!products.value) {
  throw new Error('Failed getting all products');
}
</script>

<style scoped>
.heading {
  margin-bottom: calc(-1 * var(--space-7) - var(--space-6));
}
@media (max-width: 850px) {
  .layout {
    padding-inline: 0 !important;
  }
  .heading {
    gap: var(--space-1) !important;
    margin-bottom: calc(-1 * var(--space-8) - var(--space-3));
  }
}
</style>